import './App.css';
import {Routes,Route} from "react-router"
import Home from "./Component/Pages/Home"
import Shop from './Component/Pages/Shop';
import { ShopDetails } from './Component/Pages/ShopDetails';
import { Contact } from './Component/Pages/Contact';
import { Cart } from './Component/Pages/Cart';
import { Checkout } from './Component/Pages/Checkout';
import { Testimonial } from './Component/Pages/Testimonial';
import EnqueryPage from './Component/Pages/EnqueryPage';
import Review from './Component/Pages/Review';
import Login from './Component/Pages/Login';
import Register from './Component/Pages/Register';
import Store from './Component/Pages/Store';
import Profile from './Component/Pages/Profile';
import CreatePartnership from './Component/Pages/CreatePartnership';
import WishList from './Component/Pages/WishList';
import QuestionReview from './Component/Pages/QuestionReview';
import Service from './Component/Pages/Service';
import { useEffect, useState } from 'react';
import { getQuerySupport, sendQuerySupport } from './Component/Services/Operations/ProductAPI';
import MedicalTest from './Component/Pages/MedicalTest';


function App() {
  const[supportModal,setSupportModal]=useState(false)
  const[queryMessage,setQueryMessage]=useState("")
  const [messages,setMessages]=useState([])

   const getQuery=async()=>{
      try {
        const response=await getQuerySupport()
        console.log(response);
        setMessages(response.data)
        
      } catch (error) {
        console.log(error);
        
      }
    }

  const handleSendQuery=async()=>{
    try {
      let data={
        supportType:"OTHER",
        message:queryMessage
      }
      const response=await sendQuerySupport(data)
      console.log(response);
      if(response.status===200){
        setQueryMessage("")
        getQuery()
      }
      
    } catch (error) {
      console.log(error);
      
    }
  }

  useEffect(() => {
   
    getQuery()
  }, [])
  
  return (
    <div>
      <Routes>
        <Route path='/' element={<Home/>}/>
        <Route path='/shop' element={<Shop/>}/>
        <Route path='/shop-details/:id' element={<ShopDetails/>}/>
        <Route path='/contact' element={<Contact/>}/>
        <Route path='/cart' element={<Cart/>}/>
        <Route path='/checkout' element={<Checkout/>}/>
        <Route path='/testimonial' element={<Testimonial/>}/>
        <Route path='/enquery' element={<EnqueryPage/>}/>
        <Route path='/review' element={<Review/>}/>
         <Route path='/store' element={<Store/>}/>
         <Route path='/wishlist' element={<WishList/>} />
         <Route  path='/create-partnership' element={<CreatePartnership/>}/>
        <Route path='/login' element={<Login/>}/>
          <Route path='/register' element={<Register/>}/>
          <Route path='/profile' element={<Profile/>}/>
          <Route path='/question-review' element={<QuestionReview/>}/>
          <Route path='/service' element={<Service/>}/>
            <Route path='/medical-test' element={<MedicalTest/>}/>

      </Routes>

     { supportModal?
     <div style={{position:"fixed",bottom:"100px",height:"400px",width:"300px",right:"30px",zIndex:99999,padding:"20px",backgroundColor:"white",borderTopLeftRadius:"26px",borderBottomLeftRadius:"26px",borderTopRightRadius:"26px",  boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.25)',}}>
        <p style={{position:"absolute",right:"10px",top:"10px",cursor:"pointer"}}
        onClick={()=>setSupportModal(false)}>X</p>
        <p>Ask your Query</p>  
        <div style={{height:"250px",width:"100%",border:"1px solid grey",overflowY:"scroll",borderRadius:"10px",padding:"6px"}}>
          {messages.map((sms)=><p>
            {sms.message}
          </p>)}
          </div>
          <div style={{width:"100%",display:"flex",alignItems:"center",justifyContent:"space-between",gap:"6px",padding:"5px"}}>
            <textarea
              value={queryMessage}
              onChange={(e)=>setQueryMessage(e.target.value)}
            placeholder='Ask your query...'
            style={{outline:"none",border:"1px solid grey",padding:"8px",borderRadius:"8px",width:"90%"}}
            >

            </textarea>
            <p style={{cursor:"pointer"}}
            onClick={()=>handleSendQuery()}>
              <img src='/Assets/img/send-message.png'
              style={{width:"30px"}}/></p>
            </div>
      </div>
     :
     <div onClick={()=>setSupportModal(true)}
     style={{position:"fixed",bottom:"100px",right:"30px",zIndex:99999,padding:"10px",backgroundColor:"white",borderRadius:"50%",cursor:"pointer",boxShadow: '0 6px 20px rgba(0, 0, 0, 0.45)'}}>
          <img src='/Assets/img/support.png'
          style={{width:"60px"}}/>
      </div>}
    </div>
  );
}

export default App;
